import { useEffect } from 'react';

import { Viewer } from '@vimeo/viewer';

export function useAppendRecaptchaEnterpriseTokenScript(viewer: Viewer | null) {
  useEffect(() => {
    if (viewer) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${viewer.recaptchaEnterpriseScoreBasedSiteKey}&onload=onloadCallback&render=explicit`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
      const tokenScript = document.createElement('script');
      tokenScript.async = true;
      tokenScript.defer = true;
      tokenScript.innerHTML = `function onloadCallback() {
             grecaptcha.enterprise.ready(async () => {
                const recaptcha_token = await grecaptcha.enterprise.execute('${viewer.recaptchaEnterpriseScoreBasedSiteKey}', {action:"join"});
                window.recaptcha_enterprise_token = recaptcha_token;
                var gb = document.getElementsByClassName("grecaptcha-badge")[0];
                gb.style.visibility = "hidden";
                let event = window.document.createEvent('CustomEvent');
                event.initCustomEvent(
                    'recaptcha-token-loaded',
                    true,
                    true,
                );
                document.dispatchEvent(event);
               })
        }`;
      document.body.appendChild(tokenScript);
    }
  }, [viewer]);
}
